export const ADMIN_RELAYS_API_ROOT = '/admin/relays';

export const ADMIN_RELAYS_API_PATHS = {
  LIST: `${ADMIN_RELAYS_API_ROOT}/list`,
};
